// @ts-nocheck
import { usersInitialApi as api } from './initialApi';
export const addTagTypes = [
  'trusted-devices-controller',
  'org-app-identity-controller',
  'app-identity-controller',
  'profile-v-1-controller',
  'codes-controller',
  'sso-controller',
  'otp-controller',
  'mfa-controller',
  'organization-offboard-controller',
  'migration-ovi-controller',
  'driver-profile-controller',
  'admin-controller',
  'invite-controller',
  'token-enrichment-controller',
  'cdi-health-controller',
  'Profile',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      revokeTrustedDevice: build.mutation<
        RevokeTrustedDeviceApiResponse,
        RevokeTrustedDeviceApiArg
      >({
        query: (queryArg) => ({
          url: `/devices/2025-03-25/${queryArg.id}`,
          method: 'PUT',
        }),
        invalidatesTags: ['trusted-devices-controller'],
      }),
      updateOrgLevelAppIdentity: build.mutation<
        UpdateOrgLevelAppIdentityApiResponse,
        UpdateOrgLevelAppIdentityApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-11-18/organizations/${queryArg.organizationId}/apps/${queryArg.profileId}`,
          method: 'PUT',
          body: queryArg.orgAppUpdateRequest,
        }),
        invalidatesTags: ['org-app-identity-controller'],
      }),
      updateAppIdentity: build.mutation<
        UpdateAppIdentityApiResponse,
        UpdateAppIdentityApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-11-04/apps/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.appUpdateRequest,
        }),
        invalidatesTags: ['app-identity-controller'],
      }),
      deleteAppIdentity: build.mutation<
        DeleteAppIdentityApiResponse,
        DeleteAppIdentityApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-11-04/apps/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['app-identity-controller'],
      }),
      updateProfileCustomPermissions: build.mutation<
        UpdateProfileCustomPermissionsApiResponse,
        UpdateProfileCustomPermissionsApiArg
      >({
        query: (queryArg) => ({
          url: `/2023-10-10/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.profileUpdateRequestV20231010,
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      resetAppSecret: build.mutation<
        ResetAppSecretApiResponse,
        ResetAppSecretApiArg
      >({
        query: (queryArg) => ({
          url: `/2023-03-14/apps/${queryArg.id}/secrets/${queryArg.secretType}`,
          method: 'PUT',
        }),
        invalidatesTags: ['app-identity-controller'],
      }),
      getProfileById: build.query<
        GetProfileByIdApiResponse,
        GetProfileByIdApiArg
      >({
        query: (queryArg) => ({ url: `/2021-11-15/${queryArg.id}` }),
        providesTags: ['profile-v-1-controller'],
      }),
      updateUserProfileV1: build.mutation<
        UpdateUserProfileV1ApiResponse,
        UpdateUserProfileV1ApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.profileUpdateJson,
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      updateMyLegalDocs: build.mutation<
        UpdateMyLegalDocsApiResponse,
        UpdateMyLegalDocsApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/me/terms-and-conditions`,
          method: 'PUT',
          body: queryArg.legalRequestJson,
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      updateIdentityIdByUserCode: build.mutation<
        UpdateIdentityIdByUserCodeApiResponse,
        UpdateIdentityIdByUserCodeApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/devicecodes/${queryArg.userCode}`,
          method: 'PUT',
        }),
        invalidatesTags: ['codes-controller'],
      }),
      checkTenantAssociation: build.mutation<
        CheckTenantAssociationApiResponse,
        CheckTenantAssociationApiArg
      >({
        query: (queryArg) => ({
          url: `/sso/2024-07-18/validateDomain`,
          method: 'POST',
          body: queryArg.tenantUserCheck,
        }),
        invalidatesTags: ['sso-controller'],
      }),
      verifyOtp: build.mutation<VerifyOtpApiResponse, VerifyOtpApiArg>({
        query: (queryArg) => ({
          url: `/otp/2025-03-25/verify`,
          method: 'POST',
          body: queryArg.otpVerifyRequest,
        }),
        invalidatesTags: ['otp-controller'],
      }),
      sendOtp: build.mutation<SendOtpApiResponse, SendOtpApiArg>({
        query: () => ({ url: `/otp/2025-03-25/send`, method: 'POST' }),
        invalidatesTags: ['otp-controller'],
      }),
      verifyMfa: build.mutation<VerifyMfaApiResponse, VerifyMfaApiArg>({
        query: (queryArg) => ({
          url: `/mfa/2025-03-25/verify`,
          method: 'POST',
          body: queryArg.mfaRequest,
        }),
        invalidatesTags: ['mfa-controller'],
      }),
      offboardOrganizationUsers: build.mutation<
        OffboardOrganizationUsersApiResponse,
        OffboardOrganizationUsersApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-08-11/organizations/${queryArg.organizationId}/offboard`,
          method: 'POST',
          headers: {
            'cs-idempotency-key': queryArg['cs-idempotency-key'],
          },
        }),
        invalidatesTags: ['organization-offboard-controller'],
      }),
      showGettingStarted: build.mutation<
        ShowGettingStartedApiResponse,
        ShowGettingStartedApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-07-28/${queryArg.profileId}/start/show`,
          method: 'POST',
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      dismissGettingStarted: build.mutation<
        DismissGettingStartedApiResponse,
        DismissGettingStartedApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-07-28/${queryArg.profileId}/start/dismiss`,
          method: 'POST',
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      markAppSpaceViewed: build.mutation<
        MarkAppSpaceViewedApiResponse,
        MarkAppSpaceViewedApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-07-28/${queryArg.profileId}/spaces/${queryArg.space}/viewed`,
          method: 'POST',
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      validateOviVehicleSchedules: build.mutation<
        ValidateOviVehicleSchedulesApiResponse,
        ValidateOviVehicleSchedulesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-07-14/migration/ovi/vehicleSchedules/validate`,
          method: 'POST',
          body: queryArg.validateMigratedOviVehicleSchedulesRequest,
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      validateOviPersons: build.mutation<
        ValidateOviPersonsApiResponse,
        ValidateOviPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-30/migration/ovi/persons/validate`,
          method: 'POST',
          body: queryArg.validateMigratedOviPersonsRequest,
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      activateOviPersons: build.mutation<
        ActivateOviPersonsApiResponse,
        ActivateOviPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-16/migration/ovi/persons/activate`,
          method: 'POST',
          body: queryArg.activateUsersRequest,
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      listOviVehicleSchedules: build.query<
        ListOviVehicleSchedulesApiResponse,
        ListOviVehicleSchedulesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/migration/ovi/vehicleSchedules`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            oviAccountId: queryArg.oviAccountId,
            oviFleetId: queryArg.oviFleetId,
            oviVehicleId: queryArg.oviVehicleId,
            oviPersonId: queryArg.oviPersonId,
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            assetId: queryArg.assetId,
            driverId: queryArg.driverId,
            size: queryArg.size,
          },
        }),
        providesTags: ['migration-ovi-controller'],
      }),
      syncOviVehicleSchedules: build.mutation<
        SyncOviVehicleSchedulesApiResponse,
        SyncOviVehicleSchedulesApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/migration/ovi/vehicleSchedules`,
          method: 'POST',
          body: queryArg.syncOviVehicleSchedulesRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      listOviPersons: build.query<
        ListOviPersonsApiResponse,
        ListOviPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/migration/ovi/persons`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            oviAccountId: queryArg.oviAccountId,
            oviFleetId: queryArg.oviFleetId,
            oviPersonId: queryArg.oviPersonId,
            organizationId: queryArg.organizationId,
            fleetId: queryArg.fleetId,
            userId: queryArg.userId,
            size: queryArg.size,
          },
        }),
        providesTags: ['migration-ovi-controller'],
      }),
      syncOviPersons: build.mutation<
        SyncOviPersonsApiResponse,
        SyncOviPersonsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-06-02/migration/ovi/persons`,
          method: 'POST',
          body: queryArg.syncOviPersonsRequest,
          headers: {
            'FORCE-CHANGE': queryArg['FORCE-CHANGE'],
          },
        }),
        invalidatesTags: ['migration-ovi-controller'],
      }),
      bulkGetDrivers: build.mutation<
        BulkGetDriversApiResponse,
        BulkGetDriversApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-02-10/drivers/bulk-get`,
          method: 'POST',
          body: queryArg.bulkGetDriversRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['driver-profile-controller'],
      }),
      createProfileCustomPermissions: build.mutation<
        CreateProfileCustomPermissionsApiResponse,
        CreateProfileCustomPermissionsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-11-18/organizations/apps`,
          method: 'POST',
          body: queryArg.orgAppCreateRequest,
        }),
        invalidatesTags: ['org-app-identity-controller'],
      }),
      assignVehicle: build.mutation<
        AssignVehicleApiResponse,
        AssignVehicleApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-07-15/drivers/${queryArg.driverId}/assign-vehicle`,
          method: 'POST',
          body: queryArg.driverVehicleAssignmentRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['driver-profile-controller'],
      }),
      unassignVehicles: build.mutation<
        UnassignVehiclesApiResponse,
        UnassignVehiclesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-07-15/drivers/bulk-unassign-vehicles`,
          method: 'POST',
          body: queryArg.driverVehicleBulkUnassignRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['driver-profile-controller'],
      }),
      createApp: build.mutation<CreateAppApiResponse, CreateAppApiArg>({
        query: (queryArg) => ({
          url: `/2025-07-01/apps`,
          method: 'POST',
          body: queryArg.appCreateRequest,
        }),
        invalidatesTags: ['app-identity-controller'],
      }),
      getDriverProfiles: build.query<
        GetDriverProfilesApiResponse,
        GetDriverProfilesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-06-17/drivers`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            organizationId: queryArg.organizationId,
            fleetIds: queryArg.fleetIds,
            name: queryArg.name,
            sortBy: queryArg.sortBy,
            sortOrder: queryArg.sortOrder,
            size: queryArg.size,
          },
        }),
        providesTags: ['driver-profile-controller'],
      }),
      createDriverProfile: build.mutation<
        CreateDriverProfileApiResponse,
        CreateDriverProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-06-17/drivers`,
          method: 'POST',
          body: queryArg.driverProfileCreateRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['driver-profile-controller'],
      }),
      recordLastSignedIn: build.mutation<
        RecordLastSignedInApiResponse,
        RecordLastSignedInApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-01-28/login`,
          method: 'POST',
          body: queryArg.recordLastSignedInRequest,
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      createAdministrativeUser: build.mutation<
        CreateAdministrativeUserApiResponse,
        CreateAdministrativeUserApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-01-28/admin`,
          method: 'POST',
          body: queryArg.createAdminUserProfileRequest,
        }),
        invalidatesTags: ['admin-controller'],
      }),
      cancelInvites: build.mutation<
        CancelInvitesApiResponse,
        CancelInvitesApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-12-17/invites/cancel`,
          method: 'POST',
          body: queryArg.cancelInvitesRequestDto,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
          },
        }),
        invalidatesTags: ['invite-controller'],
      }),
      resendInvites: build.mutation<
        ResendInvitesApiResponse,
        ResendInvitesApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-11-29/invites/resend`,
          method: 'POST',
          body: queryArg.resendInvitesRequestDto,
          headers: {
            'x-suppress-notification': queryArg['x-suppress-notification'],
          },
        }),
        invalidatesTags: ['invite-controller'],
      }),
      acceptInvite: build.mutation<AcceptInviteApiResponse, AcceptInviteApiArg>(
        {
          query: (queryArg) => ({
            url: `/2024-11-20/invite/accept`,
            method: 'POST',
            body: queryArg.legalRequest,
          }),
          invalidatesTags: ['invite-controller'],
        }
      ),
      inviteUsers: build.mutation<InviteUsersApiResponse, InviteUsersApiArg>({
        query: (queryArg) => ({
          url: `/2024-10-21/invites`,
          method: 'POST',
          body: queryArg.inviteUsersRequest,
          headers: {
            'x-bd-organization': queryArg['x-bd-organization'],
            'x-suppress-notification': queryArg['x-suppress-notification'],
          },
        }),
        invalidatesTags: ['invite-controller'],
      }),
      enrichToken: build.mutation<EnrichTokenApiResponse, EnrichTokenApiArg>({
        query: (queryArg) => ({
          url: `/2024-10-08/enrichForSso`,
          method: 'POST',
          body: queryArg.tokenEnrichForSsoRequest,
        }),
        invalidatesTags: ['token-enrichment-controller'],
      }),
      enrichToken1: build.mutation<EnrichToken1ApiResponse, EnrichToken1ApiArg>(
        {
          query: (queryArg) => ({
            url: `/2024-07-31/enrichForCdi`,
            method: 'POST',
            body: queryArg.tokenEnrichForCdiRequest,
          }),
          invalidatesTags: ['token-enrichment-controller'],
        }
      ),
      resetAllAppSecrets: build.mutation<
        ResetAllAppSecretsApiResponse,
        ResetAllAppSecretsApiArg
      >({
        query: (queryArg) => ({
          url: `/2023-03-14/apps/${queryArg.id}/secrets`,
          method: 'POST',
        }),
        invalidatesTags: ['app-identity-controller'],
      }),
      generateDeviceCode: build.mutation<
        GenerateDeviceCodeApiResponse,
        GenerateDeviceCodeApiArg
      >({
        query: () => ({ url: `/2021-11-15/devicecodes`, method: 'POST' }),
        invalidatesTags: ['codes-controller'],
      }),
      getIdentityIdByDeviceCode: build.mutation<
        GetIdentityIdByDeviceCodeApiResponse,
        GetIdentityIdByDeviceCodeApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/devicecodes/identityId`,
          method: 'POST',
          body: queryArg.retrieveIdentityIdRequest,
        }),
        invalidatesTags: ['codes-controller'],
      }),
      recordCurrentUserLegalAgreements: build.mutation<
        RecordCurrentUserLegalAgreementsApiResponse,
        RecordCurrentUserLegalAgreementsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-10-06/me/legal`,
          method: 'PATCH',
          body: queryArg.legalAgreementRequest,
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
      getDriverProfileById: build.query<
        GetDriverProfileByIdApiResponse,
        GetDriverProfileByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-06-17/drivers/${queryArg.id}`,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        providesTags: ['driver-profile-controller'],
      }),
      updateDriverProfile: build.mutation<
        UpdateDriverProfileApiResponse,
        UpdateDriverProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-06-17/drivers/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.driverProfileUpdateRequest,
          headers: {
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
        }),
        invalidatesTags: ['driver-profile-controller'],
      }),
      listTrustedDevices: build.query<
        ListTrustedDevicesApiResponse,
        ListTrustedDevicesApiArg
      >({
        query: () => ({ url: `/devices/2025-03-25` }),
        providesTags: ['trusted-devices-controller'],
      }),
      probeCdi: build.query<ProbeCdiApiResponse, ProbeCdiApiArg>({
        query: () => ({ url: `/2026-09-08/cdi/health` }),
        providesTags: ['cdi-health-controller'],
      }),
      getOffboardStatus: build.query<
        GetOffboardStatusApiResponse,
        GetOffboardStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-08-11/organizations/${queryArg.organizationId}/offboard/${queryArg.jobId}`,
        }),
        providesTags: ['organization-offboard-controller'],
      }),
      retrieveResourceCounts: build.query<
        RetrieveResourceCountsApiResponse,
        RetrieveResourceCountsApiArg
      >({
        query: (queryArg) => ({
          url: `/2026-07-28/${queryArg.profileId}/resources/count`,
          params: {
            fleetId: queryArg.fleetId,
          },
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      getCustomPermissions: build.query<
        GetCustomPermissionsApiResponse,
        GetCustomPermissionsApiArg
      >({
        query: () => ({ url: `/2026-02-24/apps/customPermissions` }),
        providesTags: ['app-identity-controller'],
      }),
      getAppIdentities: build.query<
        GetAppIdentitiesApiResponse,
        GetAppIdentitiesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-10-07/apps`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            size: queryArg.size,
            email: queryArg.email,
            clientId: queryArg.clientId,
          },
        }),
        providesTags: ['app-identity-controller'],
      }),
      findDriversByVins: build.query<
        FindDriversByVinsApiResponse,
        FindDriversByVinsApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-06-17/drivers/byVins`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
            'cs-organization': queryArg['cs-organization'],
            'cs-fleet': queryArg['cs-fleet'],
          },
          params: {
            vins: queryArg.vins,
            size: queryArg.size,
          },
        }),
        providesTags: ['driver-profile-controller'],
      }),
      searchUserProfiles: build.query<
        SearchUserProfilesApiResponse,
        SearchUserProfilesApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-02-11`,
          headers: {
            'cs-continuation-token': queryArg['cs-continuation-token'],
          },
          params: {
            organizationId: queryArg.organizationId,
            fleetIds: queryArg.fleetIds,
            statuses: queryArg.statuses,
            roles: queryArg.roles,
            inviteStatuses: queryArg.inviteStatuses,
            name: queryArg.name,
            email: queryArg.email,
            sortBy: queryArg.sortBy,
            sortOrder: queryArg.sortOrder,
            size: queryArg.size,
          },
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      findProfilesByOrgIdAndEmail: build.query<
        FindProfilesByOrgIdAndEmailApiResponse,
        FindProfilesByOrgIdAndEmailApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-01-14`,
          params: {
            organizationId: queryArg.organizationId,
            email: queryArg.email,
          },
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      getCdiUserProfile: build.query<
        GetCdiUserProfileApiResponse,
        GetCdiUserProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/2024-09-30/cdi/${queryArg.cdiProfileId}`,
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      findAllProfilesBeta: build.query<
        FindAllProfilesBetaApiResponse,
        FindAllProfilesBetaApiArg
      >({
        query: (queryArg) => ({
          url: `/2023-09-25-BETA`,
          headers: {
            continuationToken: queryArg.continuationToken,
          },
          params: {
            filters: queryArg.filters,
            size: queryArg.size,
          },
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      findAllProfilesBy: build.query<
        FindAllProfilesByApiResponse,
        FindAllProfilesByApiArg
      >({
        query: () => ({ url: `/2021-11-15` }),
        providesTags: ['profile-v-1-controller'],
      }),
      getContactInfo: build.query<
        GetContactInfoApiResponse,
        GetContactInfoApiArg
      >({
        query: (queryArg) => ({
          url: `/2021-11-15/${queryArg.id}/contactInfo`,
        }),
        providesTags: ['profile-v-1-controller'],
      }),
      get20211115Me: build.query<Get20211115MeApiResponse, Get20211115MeApiArg>(
        {
          query: () => ({ url: `/2021-11-15/me` }),
          providesTags: ['Profile'],
        }
      ),
      deleteAdministrativeUser: build.mutation<
        DeleteAdministrativeUserApiResponse,
        DeleteAdministrativeUserApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-10-07/admin/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['admin-controller'],
      }),
      deleteUserProfile: build.mutation<
        DeleteUserProfileApiResponse,
        DeleteUserProfileApiArg
      >({
        query: (queryArg) => ({
          url: `/2025-05-06/${queryArg.id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['profile-v-1-controller'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as usersApi };
export type RevokeTrustedDeviceApiResponse =
  /** status 200 OK */ GmResponseCommonTrustedDeviceResponse;
export type RevokeTrustedDeviceApiArg = {
  id: string;
};
export type UpdateOrgLevelAppIdentityApiResponse =
  /** status 200 OK */ GmResponseCommonVoid;
export type UpdateOrgLevelAppIdentityApiArg = {
  /** The ID of the app profile to update. */
  profileId: string;
  /** The ID of the organization the profile belongs to. */
  organizationId: string;
  orgAppUpdateRequest: OrgAppUpdateRequest;
};
export type UpdateAppIdentityApiResponse =
  /** status 200 Successfully updated system-level app identity profile. */ GmResponseCommonVoid;
export type UpdateAppIdentityApiArg = {
  /** App identity profile ID to update */
  id: string;
  appUpdateRequest: AppUpdateRequest;
};
export type DeleteAppIdentityApiResponse =
  /** status 200 OK */ GmResponseCommonVoid;
export type DeleteAppIdentityApiArg = {
  /** Profile ID of the app identity to delete. */
  id: string;
};
export type UpdateProfileCustomPermissionsApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type UpdateProfileCustomPermissionsApiArg = {
  /** Profile id to update. */
  id: string;
  profileUpdateRequestV20231010: ProfileUpdateRequestV20231010;
};
export type ResetAppSecretApiResponse =
  /** status 200 Successfully reset app secret. */ GmResponseCommonSecret;
export type ResetAppSecretApiArg = {
  /** Profile ID for app identity account */
  id: string;
  /** Secret to reset - primary or secondary */
  secretType: 'PRIMARY' | 'SECONDARY';
};
export type GetProfileByIdApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type GetProfileByIdApiArg = {
  /** Profile id to get. */
  id: string;
};
export type UpdateUserProfileV1ApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type UpdateUserProfileV1ApiArg = {
  id: string;
  profileUpdateJson: ProfileUpdateJson;
};
export type UpdateMyLegalDocsApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type UpdateMyLegalDocsApiArg = {
  legalRequestJson: LegalRequestJson;
};
export type UpdateIdentityIdByUserCodeApiResponse =
  /** status 200 OK */ GmResponseCommonCodesResponse;
export type UpdateIdentityIdByUserCodeApiArg = {
  userCode: string;
};
export type CheckTenantAssociationApiResponse = unknown;
export type CheckTenantAssociationApiArg = {
  tenantUserCheck: TenantUserCheck;
};
export type VerifyOtpApiResponse = /** status 200 OK */ GmResponseCommonBoolean;
export type VerifyOtpApiArg = {
  otpVerifyRequest: OtpVerifyRequest;
};
export type SendOtpApiResponse = unknown;
export type SendOtpApiArg = void;
export type VerifyMfaApiResponse =
  /** status 200 OK */ GmResponseCommonMfaResponse;
export type VerifyMfaApiArg = {
  mfaRequest: MfaRequest;
};
export type OffboardOrganizationUsersApiResponse =
  /** status 200 OK */ GmResponseCommonOffboardKickoffResponse;
export type OffboardOrganizationUsersApiArg = {
  /** The organization to off-board. */
  organizationId: string;
  /** Identifies the close run asking, as close:{organizationId}:{runEpoch}:users. */
  'cs-idempotency-key'?: string;
};
export type ShowGettingStartedApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type ShowGettingStartedApiArg = {
  /** Profile id to show the getting started experience for. */
  profileId: string;
};
export type DismissGettingStartedApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type DismissGettingStartedApiArg = {
  /** Profile id to dismiss the getting started experience for. */
  profileId: string;
};
export type MarkAppSpaceViewedApiResponse =
  /** status 200 The space was recorded as viewed (or was already viewed). */ GmResponseCommonProfileResponse;
export type MarkAppSpaceViewedApiArg = {
  /** Profile id to update. */
  profileId: string;
  /** Application space code that was viewed, e.g. "vehicles" or "business-profile". Matching is case-insensitive. */
  space: 'BUSINESS_PROFILE' | 'VEHICLES' | 'DRIVERS' | 'USERS' | 'GEOFENCES';
};
export type ValidateOviVehicleSchedulesApiResponse =
  /** status 200 OK */ GmResponseCommonValidateMigratedOviVehicleSchedulesResponse;
export type ValidateOviVehicleSchedulesApiArg = {
  validateMigratedOviVehicleSchedulesRequest: ValidateMigratedOviVehicleSchedulesRequest;
};
export type ValidateOviPersonsApiResponse =
  /** status 200 OK */ GmResponseCommonValidateMigratedOviPersonsResponse;
export type ValidateOviPersonsApiArg = {
  validateMigratedOviPersonsRequest: ValidateMigratedOviPersonsRequest;
};
export type ActivateOviPersonsApiResponse =
  /** status 200 OK */ GmResponseCommonActivateUsersResponse;
export type ActivateOviPersonsApiArg = {
  activateUsersRequest: ActivateUsersRequest;
};
export type ListOviVehicleSchedulesApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageMigratedVehicleSchedule;
export type ListOviVehicleSchedulesApiArg = {
  oviAccountId?: string;
  oviFleetId?: string;
  oviVehicleId?: string;
  oviPersonId?: string;
  organizationId?: string;
  fleetId?: string;
  assetId?: string;
  driverId?: string;
  /** Max number of items per page for pagination. */
  size?: number;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
};
export type SyncOviVehicleSchedulesApiResponse =
  /** status 200 OK */ GmResponseCommonSyncOviVehicleSchedulesResponse;
export type SyncOviVehicleSchedulesApiArg = {
  'FORCE-CHANGE'?: boolean;
  syncOviVehicleSchedulesRequest: SyncOviVehicleSchedulesRequest;
};
export type ListOviPersonsApiResponse =
  /** status 200 OK */ GmResponseCommonGmPageProfile;
export type ListOviPersonsApiArg = {
  oviAccountId?: string;
  oviFleetId?: string;
  oviPersonId?: string;
  organizationId?: string;
  fleetId?: string;
  userId?: string;
  size?: number;
  'cs-continuation-token'?: string;
};
export type SyncOviPersonsApiResponse =
  /** status 200 OK */ GmResponseCommonSyncOviPersonsResponse;
export type SyncOviPersonsApiArg = {
  'FORCE-CHANGE'?: boolean;
  syncOviPersonsRequest: SyncOviPersonsRequest;
};
export type BulkGetDriversApiResponse =
  /** status 200 OK */ GmResponseCommonBulkGetDriversResponse;
export type BulkGetDriversApiArg = {
  'cs-organization': string;
  'cs-fleet'?: string;
  bulkGetDriversRequest: BulkGetDriversRequest;
};
export type CreateProfileCustomPermissionsApiResponse =
  /** status 201 Created */ GmResponseCommonOrgAppCreateResponse;
export type CreateProfileCustomPermissionsApiArg = {
  orgAppCreateRequest: OrgAppCreateRequest;
};
export type AssignVehicleApiResponse = unknown;
export type AssignVehicleApiArg = {
  /** Driver profile id to assign vehicle to. */
  driverId: string;
  'cs-organization': string;
  'cs-fleet'?: string;
  driverVehicleAssignmentRequest: DriverVehicleAssignmentRequest;
};
export type UnassignVehiclesApiResponse = unknown;
export type UnassignVehiclesApiArg = {
  'cs-organization': string;
  'cs-fleet'?: string;
  driverVehicleBulkUnassignRequest: DriverVehicleBulkUnassignRequest;
};
export type CreateAppApiResponse =
  /** status 201 Successfully created app account. */ GmResponseCommonAppCreateResponse;
export type CreateAppApiArg = {
  appCreateRequest: AppCreateRequest;
};
export type GetDriverProfilesApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseDriverProfileResponse;
export type GetDriverProfilesApiArg = {
  /** Filter by organization ID. */
  organizationId?: any;
  /** Filter by list of fleet IDs. */
  fleetIds?: any;
  /** Search by driver name. */
  name?: string;
  /** Sort driver profiles by field. */
  sortBy?: 'EMAIL' | 'NAME' | 'PHONE_NUMBER';
  /** Sort order for driver profiles. */
  sortOrder?: 'ASC' | 'DESC';
  /** Max number of items per page for pagination. */
  size?: number;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
  'cs-organization': string;
  'cs-fleet'?: string[];
};
export type CreateDriverProfileApiResponse =
  /** status 200 OK */ GmResponseCommonDriverProfileCreateResponse;
export type CreateDriverProfileApiArg = {
  'cs-organization': string;
  'cs-fleet': string;
  driverProfileCreateRequest: DriverProfileCreateRequest;
};
export type RecordLastSignedInApiResponse = unknown;
export type RecordLastSignedInApiArg = {
  recordLastSignedInRequest: RecordLastSignedInRequest;
};
export type CreateAdministrativeUserApiResponse =
  /** status 201 Created */ GmResponseCommonProfileResponse;
export type CreateAdministrativeUserApiArg = {
  createAdminUserProfileRequest: CreateAdminUserProfileRequest;
};
export type CancelInvitesApiResponse =
  /** status 200 OK */ GmResponseCommonCancelInvitesResponseDto;
export type CancelInvitesApiArg = {
  /** The organization ID to identify organization for invitation's. */
  'x-bd-organization': string;
  cancelInvitesRequestDto: CancelInvitesRequestDto;
};
export type ResendInvitesApiResponse =
  /** status 200 OK */ GmResponseCommonResendInvitesResponseDto;
export type ResendInvitesApiArg = {
  /** Suppresses email notifications if set to true. */
  'x-suppress-notification'?: boolean;
  resendInvitesRequestDto: ResendInvitesRequestDto;
};
export type AcceptInviteApiResponse =
  /** status 200 OK */ GmResponseCommonProfile;
export type AcceptInviteApiArg = {
  legalRequest: LegalRequest;
};
export type InviteUsersApiResponse =
  /** status 200 OK */ GmResponseCommonInviteUsersResponse;
export type InviteUsersApiArg = {
  /** The organization ID to identify the invitee user's organization. */
  'x-bd-organization': string;
  /** Suppresses email notifications if set to true. */
  'x-suppress-notification'?: boolean;
  inviteUsersRequest: InviteUsersRequest;
};
export type EnrichTokenApiResponse =
  /** status 200 CS profile was found. */ TokenEnrichResponse;
export type EnrichTokenApiArg = {
  tokenEnrichForSsoRequest: TokenEnrichForSsoRequest;
};
export type EnrichToken1ApiResponse =
  /** status 200 CS profile was found. */ TokenEnrichResponse;
export type EnrichToken1ApiArg = {
  tokenEnrichForCdiRequest: TokenEnrichForCdiRequest;
};
export type ResetAllAppSecretsApiResponse =
  /** status 200 Successfully reset one or both app secret types. */ GmResponseCommonMapStringSecret;
export type ResetAllAppSecretsApiArg = {
  /** Id for app identity account (profile id) */
  id: string;
};
export type GenerateDeviceCodeApiResponse =
  /** status 200 OK */ GmResponseCommonCodesResponse;
export type GenerateDeviceCodeApiArg = void;
export type GetIdentityIdByDeviceCodeApiResponse =
  /** status 200 Successfully retrieved identityId. */ GmResponseCommonIdentityIdResponse;
export type GetIdentityIdByDeviceCodeApiArg = {
  retrieveIdentityIdRequest: RetrieveIdentityIdRequest;
};
export type RecordCurrentUserLegalAgreementsApiResponse =
  /** status 200 OK */ GmResponseCommonLegalResponse;
export type RecordCurrentUserLegalAgreementsApiArg = {
  legalAgreementRequest: LegalAgreementRequest;
};
export type GetDriverProfileByIdApiResponse =
  /** status 200 OK */ GmResponseCommonDriverProfileResponse;
export type GetDriverProfileByIdApiArg = {
  /** Driver profile id to get. */
  id: string;
  'cs-organization': string;
  'cs-fleet'?: string;
};
export type UpdateDriverProfileApiResponse =
  /** status 200 OK */ GmResponseCommonDriverProfileResponse;
export type UpdateDriverProfileApiArg = {
  /** Driver profile id to update. */
  id: string;
  'cs-organization': string;
  'cs-fleet'?: string;
  driverProfileUpdateRequest: DriverProfileUpdateRequest;
};
export type ListTrustedDevicesApiResponse =
  /** status 200 OK */ GmResponseCommonListTrustedDeviceResponse;
export type ListTrustedDevicesApiArg = void;
export type ProbeCdiApiResponse =
  /** status 200 OK */ GmResponseCommonCdiHealthResult;
export type ProbeCdiApiArg = void;
export type GetOffboardStatusApiResponse =
  /** status 200 OK */ GmResponseCommonOffboardStatusResponse;
export type GetOffboardStatusApiArg = {
  /** The organization being off-boarded. */
  organizationId: string;
  /** The run to report on. */
  jobId: string;
};
export type RetrieveResourceCountsApiResponse =
  /** status 200 Available resource counts were retrieved. */ GmResponseCommonRetrieveResourceCountsResponse;
export type RetrieveResourceCountsApiArg = {
  /** Profile whose accessible resources are counted. */
  profileId: string;
  /** Optional fleet used to restrict resource counts. */
  fleetId?: string;
};
export type GetCustomPermissionsApiResponse =
  /** status 200 OK */ GmResponseCommonSetString;
export type GetCustomPermissionsApiArg = void;
export type GetAppIdentitiesApiResponse =
  /** status 200 Successfully retrieved app identities. */ GmResponseCommonGmPageAppIdentity;
export type GetAppIdentitiesApiArg = {
  /** Max number of items per page for pagination */
  size?: number;
  /** The email of the app identity to search for. */
  email?: string;
  /** The clientId of the app identity to search for. */
  clientId?: string;
  /** Continuation token for pagination */
  'cs-continuation-token'?: string;
};
export type FindDriversByVinsApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseDriverWithAssignedVehicles;
export type FindDriversByVinsApiArg = {
  /** List of Vehicle Identification Numbers to search for */
  vins: string[];
  /** Max number of items per page for pagination. */
  size?: number;
  /** Continuation token for pagination. */
  'cs-continuation-token'?: string;
  'cs-organization': string;
  'cs-fleet'?: string;
};
export type SearchUserProfilesApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseProfile;
export type SearchUserProfilesApiArg = {
  /** Filter by organization ID. */
  organizationId?: string;
  /** Filter by list of fleet IDs. */
  fleetIds?: string[];
  /** Filter by list of profile statuses. */
  statuses?: (
    | 'CONTACT'
    | 'ACTIVE'
    | 'DISABLED'
    | 'PENDING'
    | 'RETIRED'
    | 'DELETED'
  )[];
  /** Filter by list of profile roles. */
  roles?: (
    | 'TECHNICAL_MANAGER'
    | 'SYSTEM_MANAGER'
    | 'ORG_MANAGER'
    | 'FLEET_MANAGER'
    | 'OPERATOR'
    | 'SYSTEM_READER'
    | 'CUSTOM_ACCESS_ORG_LEVEL'
    | 'CUSTOM_ACCESS_SYS_LEVEL'
  )[];
  /** Filter by list of profile invite statuses. */
  inviteStatuses?: ('PENDING' | 'SENT' | 'EXPIRED' | 'CANCELED' | 'ACCEPTED')[];
  /** Search by profile name */
  name?: string;
  /** Search by profile email */
  email?: string;
  /** Sort profiles by field */
  sortBy?:
    | 'EMAIL'
    | 'NAME'
    | 'ROLE'
    | 'INVITE_STATUS'
    | 'LAST_SIGNED_IN'
    | 'CREATION_DATE';
  /** Sort order profiles */
  sortOrder?: 'ASC' | 'DESC';
  /** Max number of items per page for pagination */
  size?: number;
  /** Continuation token for pagination */
  'cs-continuation-token'?: string;
};
export type FindProfilesByOrgIdAndEmailApiResponse =
  /** status 200 OK */ GmResponseCommonListProfileResponse;
export type FindProfilesByOrgIdAndEmailApiArg = {
  /** Asset's identification. */
  organizationId: string;
  /** State to transition. */
  email: string;
};
export type GetCdiUserProfileApiResponse =
  /** status 200 CDI user details alongside matching CSP profile information if available. */ GmResponseCommonCdiUserProfile;
export type GetCdiUserProfileApiArg = {
  cdiProfileId: string;
};
export type FindAllProfilesBetaApiResponse =
  /** status 200 OK */ GmResponseCommonPaginatedDataResponseProfile;
export type FindAllProfilesBetaApiArg = {
  /** Filters to apply to the query. */
  filters?: any;
  size?: number;
  continuationToken?: string;
};
export type FindAllProfilesByApiResponse =
  /** status 200 OK */ GmResponseCommonListProfileResponse;
export type FindAllProfilesByApiArg = void;
export type GetContactInfoApiResponse =
  /** status 200 OK */ GmResponseCommonContactInfo;
export type GetContactInfoApiArg = {
  /** User id to get corresponding contact from. */
  id: string;
};
export type Get20211115MeApiResponse =
  /** status 200 OK */ GmResponseCommonProfileResponse;
export type Get20211115MeApiArg = void;
export type DeleteAdministrativeUserApiResponse =
  /** status 200 OK */ GmResponseCommonVoid;
export type DeleteAdministrativeUserApiArg = {
  /** Profile ID of the administrative user to delete. */
  id: string;
};
export type DeleteUserProfileApiResponse =
  /** status 200 OK */ GmResponseCommonBoolean;
export type DeleteUserProfileApiArg = {
  /** ID of the user to delete. */
  id: string;
};
export type TrustedDeviceResponse = {
  id?: string;
  createdAt?: string;
  lastAuthAt?: string;
  expiresAt?: string;
  revoked?: boolean;
  deviceInfo?: string;
};
export type GmResponseError = {
  errorType: 'GENERIC' | 'VALIDATION';
  message: string;
  errorCode: string;
};
export type GmResponseCommonTrustedDeviceResponse = {
  result?: TrustedDeviceResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonVoid = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommon = {
  result?: any;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrgAppUpdateRequest = {
  /** Status of the app identity. */
  status: 'ACTIVE' | 'DISABLED';
  /** Custom permissions for the app identity. Can be empty. */
  permissions: string[];
  /** Email address for the app identity used as a contact email. */
  contactEmail: string;
  /** Description for the app identity. */
  description: string;
};
export type AppUpdateRequest = {
  /** Status of the app identity. */
  status: 'ACTIVE' | 'DISABLED';
  /** Custom permissions for the app identity. Can be empty. */
  permissions: string[];
  /** Email address for the app identity used as a contact email. */
  contactEmail: string;
  /** Description for the app identity. */
  description: string;
};
export type AddressDto = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
};
export type HierarchyObjectView = {
  id?: string;
  name?: string;
  countryOfOperation?: 'US' | 'MX' | 'CA';
  currency?: string;
};
export type EligibleAssetTypeDto = {
  provider: string;
};
export type InviteDto = {
  status?: 'PENDING' | 'SENT' | 'EXPIRED' | 'CANCELED' | 'ACCEPTED';
  activationState?:
    | 'MIGRATION_IN_PROGRESS'
    | 'AWAITING_ACCOUNT_ADMIN'
    | 'READY_TO_ACCEPT_TERMS';
  acceptedDate?: string;
  plannedExpiredDate?: string;
  lastExpiredDate?: string;
  lastInvitedBy?: string;
  lastInvitedDate?: string;
  lastResentBy?: string;
  lastResentDate?: string;
  lastCanceledBy?: string;
  lastCanceledDate?: string;
};
export type LegalDocumentResponse = {
  accepted?: boolean;
  acceptedOn?: string;
  source?: string;
};
export type LegalAgreementDocumentResponse = {
  type?: 'GMF_DATA_SHARING';
  accepted?: boolean;
  acceptedOn?: string;
  termsVersion?: string;
  source?: string;
};
export type LegalResponse = {
  termsAndConditions?: LegalDocumentResponse;
  privacyPolicy?: LegalDocumentResponse;
  agreements?: LegalAgreementDocumentResponse[];
};
export type UserPreferencesDto = {
  locale: string;
  timeZone?: string;
  doNotShowLegalNotice?: boolean;
  showGettingStarted?: boolean;
};
export type MeasurementDto = {
  typeKey?: string;
  unitCode?: string;
};
export type Measurements = {
  unitSystem?: string;
  distance?: MeasurementDto;
  speed?: MeasurementDto;
  capacity?: MeasurementDto;
  fuelConsumption?: MeasurementDto;
  electricConsumption?: MeasurementDto;
  energy?: MeasurementDto;
  pressure?: MeasurementDto;
  temperature?: MeasurementDto;
  emission?: MeasurementDto;
};
export type FormatStyleDto = {
  typeKey?: string;
  styleCode?: string;
  pattern?: string;
};
export type AddressFormatDto = {
  styleCode?: string;
  line1Pattern?: string;
  line2Pattern?: string;
  cityLinePattern?: string;
  oneLinePattern?: string;
};
export type FirstDayOfWeekDto = {
  firstDayOfWeekCode?: string;
};
export type FormatStyles = {
  date?: FormatStyleDto;
  time?: FormatStyleDto;
  dateTime?: FormatStyleDto;
  currency?: FormatStyleDto;
  phone?: FormatStyleDto;
  number?: FormatStyleDto;
  address?: AddressFormatDto;
  firstDayOfWeek?: FirstDayOfWeekDto;
};
export type EffectiveUserPreferencesDto = {
  measurements?: Measurements;
  formats?: FormatStyles;
  locale?: string;
  timeZone?: string;
  unitSystem?: string;
  units?: {
    [key: string]: string;
  };
  fractionDigits?: {
    [key: string]: number;
  };
  dateStyle?: string;
  clockConvention?: string;
  firstDayOfWeek?: string;
  currencyCode?: string;
};
export type Secret = {
  startDateTime?: string;
  endDateTime?: string;
  secretText?: string;
  hint?: string;
};
export type AppSettingsDto = {
  clientId?: string;
  primarySecret?: Secret;
  secondarySecret?: Secret;
  email?: string;
  description?: string;
};
export type ProfileResponse = {
  id?: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  email?: string;
  phoneNumber?: string;
  address?: AddressDto;
  status?: string;
  role?: string;
  organization?: HierarchyObjectView;
  fleet?: HierarchyObjectView;
  eligibleAssetTypes?: EligibleAssetTypeDto[];
  invite?: InviteDto;
  legal?: LegalResponse;
  lastSignedInDate?: string;
  userPreferences?: UserPreferencesDto;
  effectiveUserPreferences?: EffectiveUserPreferencesDto;
  type?: string;
  appSettings?: AppSettingsDto;
  cdiProfileId?: string;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  migrated?: boolean;
  viewedAppSpaceCodes?: (
    | 'BUSINESS_PROFILE'
    | 'VEHICLES'
    | 'DRIVERS'
    | 'USERS'
    | 'GEOFENCES'
  )[];
};
export type GmResponseCommonProfileResponse = {
  result?: ProfileResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ProfileUpdateRequestV20231010 = {
  /** Role of the user. */
  role: string;
  /** Status of the user. */
  status?: string;
  /** Fleet ID */
  fleetId?: string;
  /** List of eligible asset types for the user. */
  eligibleAssetTypes?: EligibleAssetTypeDto[];
  /** User preferences */
  userPreferences?: UserPreferencesDto;
};
export type GmResponseCommonSecret = {
  result?: Secret;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ProfileUpdateJson = {
  role: string;
  status: string;
  fleetId?: string;
  eligibleAssetTypes?: EligibleAssetTypeDto[];
  userPreferences?: UserPreferencesDto;
};
export type UrlsJson = {
  termsAndConditions: string;
  privacyPolicy: string;
};
export type LegalRequestJson = {
  /** URLs for legal requests. */
  urls: UrlsJson;
  /** Accepted status for legal requests. */
  accepted: boolean;
};
export type CodesResponse = {
  userCode?: string;
  deviceCode?: string;
  expiresIn?: number;
};
export type GmResponseCommonCodesResponse = {
  result?: CodesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TenantUserCheck = {
  email: string;
};
export type GmResponseCommonBoolean = {
  result?: boolean;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OtpVerifyRequest = {
  otp: string;
};
export type MfaToken = {
  tokenId?: string;
  token?: string;
  expiration?: number;
};
export type MfaResponse = {
  authSuccess?: boolean;
  message?: string;
  token?: MfaToken;
};
export type GmResponseCommonMfaResponse = {
  result?: MfaResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type MfaRequest = {
  tokens?: {
    [key: string]: string;
  };
  deviceFingerprint?: string;
  userAgent?: string;
  otp?: string;
  rememberDevice?: boolean;
};
export type OffboardKickoffResponse = {
  jobId?: string;
};
export type GmResponseCommonOffboardKickoffResponse = {
  result?: OffboardKickoffResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidationError = {
  code?:
    | 'NOT_FOUND'
    | 'NO_ASSIGNMENT_FOUND'
    | 'INVALID_STATE'
    | 'INVALID_FIELD';
  field?: string;
  message?: string;
};
export type ValidateMigratedOviVehicleSchedulesResponseEntry = {
  valid?: boolean;
  error?: ValidationError;
  vin?: string;
  scheduleId?: string;
};
export type ValidateMigratedOviVehicleSchedulesResponse = {
  allOviVehicleSchedulesMatched?: boolean;
  allCspDriverAssignmentsMatched?: boolean;
  vehicles?: ValidateMigratedOviVehicleSchedulesResponseEntry[];
};
export type GmResponseCommonValidateMigratedOviVehicleSchedulesResponse = {
  result?: ValidateMigratedOviVehicleSchedulesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ValidateMigratedOviVehicleSchedulesRequestEntry = {
  scheduleId: string;
  vehicleId: string;
  vin: string;
  personId: string;
  startTime: string;
  endTime: string;
};
export type ValidateMigratedOviVehicleSchedulesRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  schedules: ValidateMigratedOviVehicleSchedulesRequestEntry[];
};
export type ValidateMigratedOviPersonsResponseEntry = {
  valid?: boolean;
  error?: ValidationError;
  oviPersonId?: string;
  cspProfileId?: string;
};
export type ValidateMigratedOviPersonsResponse = {
  allOviPersonIdsMatched?: boolean;
  allCspProfileIdsMatched?: boolean;
  persons?: ValidateMigratedOviPersonsResponseEntry[];
};
export type GmResponseCommonValidateMigratedOviPersonsResponse = {
  result?: ValidateMigratedOviPersonsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OviAddress = {
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
  addressType?: 'billing' | 'home' | 'work';
  countryCode?: string;
  stateCode?: string;
  city?: string;
  street?: string;
  house?: string;
  zipCode?: string;
  postBox?: string;
  district?: string;
};
export type OviContact = {
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
  contactType?: 'email' | 'phone';
  contactLabel?: string;
  contactDescription?: string;
};
export type ValidateMigratedOviPersonsRequestEntry = {
  personId: string;
  fleetId?: string;
  roleCode: 'manager' | 'driver';
  statusCode:
    | 'active'
    | 'inactive'
    | 'invited'
    | 'pending'
    | 'retired'
    | 'verified';
  firstName?: string;
  lastName?: string;
  userLanguage?: string;
  timezone?: string;
  addresses?: OviAddress[];
  contacts?: OviContact[];
};
export type ValidateMigratedOviPersonsRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  persons: ValidateMigratedOviPersonsRequestEntry[];
};
export type ActivateUsersResponseEntry = {
  /** CSP profile ID. */
  cspProfileId?: string;
  /** OVI person ID. */
  oviPersonId?: string;
  /** True when the profile is provisioned, including one already active, provisioned by an earlier request, or an SSO user with no CDI account; false when provisioning failed. A profile provisioned here stays PENDING until it accepts terms. */
  activated?: boolean;
};
export type ActivateUsersResponse = {
  /** Activation result for each migrated profile processed by this request. */
  users?: ActivateUsersResponseEntry[];
};
export type GmResponseCommonActivateUsersResponse = {
  result?: ActivateUsersResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ActivateUsersRequest = {
  /** OVI business account ID. */
  oviAccountId: string;
  /** CSP organization ID. */
  cspOrganizationId: string;
};
export type DriverAssignedVehicle = {
  /** Vehicle Identification Number (VIN) */
  vin: string;
  /** Name for the vehicle */
  vehicleName: string;
  /** Vehicle manufacturer */
  make: string;
  /** Vehicle model */
  model: string;
  /** Vehicle manufacturing year */
  year?: number;
  /** URL for an image of the vehicle */
  vehicleImageSource?: string;
  /** Date when the vehicle was updated */
  updatedDateTime?: string;
  /** Date when the vehicle assignment was created */
  createdDateTime?: string;
};
export type MigratedDriverProfile = {
  oviVehicleIds?: string[];
  assignedVehicles?: DriverAssignedVehicle[];
};
export type MigratedVehicleSchedule = {
  userId?: string;
  organizationId?: string;
  fleetId?: string;
  driverProfile?: MigratedDriverProfile;
};
export type GmPageMigratedVehicleSchedule = {
  items: MigratedVehicleSchedule[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageMigratedVehicleSchedule = {
  result?: GmPageMigratedVehicleSchedule;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type EntryError = {
  errorCode?: string;
  errorMessage?: string;
};
export type SyncOviVehicleSchedulesResponseEntry = {
  success?: boolean;
  error?: EntryError;
  scheduleId?: string;
  assetId?: string;
  userId?: string;
  changeOp?: 'ASSIGNED' | 'UNASSIGNED' | 'NO_CHANGE';
};
export type SyncOviVehicleSchedulesResponse = {
  schedules?: SyncOviVehicleSchedulesResponseEntry[];
};
export type GmResponseCommonSyncOviVehicleSchedulesResponse = {
  result?: SyncOviVehicleSchedulesResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviVehicleSchedulesRequestEntry = {
  scheduleId: string;
  vehicleId: string;
  vin: string;
  personId: string;
  startTime: string;
  endTime: string;
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
};
export type SyncOviVehicleSchedulesRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  schedules: SyncOviVehicleSchedulesRequestEntry[];
};
export type Address = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
};
export type LegalDocument = {
  accepted?: boolean;
  acceptedOn?: string;
  source?: string;
};
export type LegalAgreement = {
  type?: 'GMF_DATA_SHARING';
  accepted?: boolean;
  acceptedOn?: string;
  termsVersion?: string;
  source?: string;
};
export type Legal = {
  termsAndConditions?: LegalDocument;
  privacyPolicy?: LegalDocument;
  agreements?: LegalAgreement[];
};
export type EligibleAssetType = {
  provider?: string;
};
export type Invite = {
  status?: 'PENDING' | 'SENT' | 'EXPIRED' | 'CANCELED' | 'ACCEPTED';
  activationState?:
    | 'MIGRATION_IN_PROGRESS'
    | 'AWAITING_ACCOUNT_ADMIN'
    | 'READY_TO_ACCEPT_TERMS';
  acceptedDate?: string;
  plannedExpiredDate?: string;
  lastExpiredDate?: string;
  lastInvitedBy?: string;
  lastInvitedDate?: string;
  lastResentBy?: string;
  lastResentDate?: string;
  lastCanceledBy?: string;
  lastCanceledDate?: string;
};
export type UserPreferences = {
  locale?: string;
  timeZone?: string;
  doNotShowLegalNotice?: boolean;
  showGettingStarted?: boolean;
};
export type AppSettings = {
  objectId?: string;
  clientId?: string;
  email?: string;
  description?: string;
  displayName?: string;
  primarySecret?: Secret;
  secondarySecret?: Secret;
};
export type DriverProfile = {
  /** Driver's license number for identification and verification purposes */
  licenseNumber?: string;
  /** Two-letter state or province code where the driver's license was issued */
  licenseState?: string;
  /** Unique employee identifier within the organization */
  employeeId?: string;
  /** Date when the driver started employment */
  employeeStartDate?: string;
  /** Additional notes or comments about the driver */
  notes?: string;
  /** List of vehicles assigned to this driver */
  assignedVehicles?: DriverAssignedVehicle[];
  /** OVI vehicle IDs associated with this driver's vehicle schedule assignments */
  oviVehicleIds?: string[];
  /** The hvr change sequence of OVI vehicle_schedules, used for OVI migration */
  oviChangeSequence?: string;
  /** Latitude coordinate of the driver's address location */
  latitudeOfDriverAddress?: number;
  /** Longitude coordinate of the driver's address location */
  longitudeOfDriverAddress?: number;
};
export type Profile = {
  id?: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  email?: string;
  description?: string;
  phoneNumber?: string;
  address?: Address;
  status?:
    | 'CONTACT'
    | 'ACTIVE'
    | 'DISABLED'
    | 'PENDING'
    | 'RETIRED'
    | 'DELETED';
  role?:
    | 'TECHNICAL_MANAGER'
    | 'SYSTEM_MANAGER'
    | 'ORG_MANAGER'
    | 'FLEET_MANAGER'
    | 'OPERATOR'
    | 'SYSTEM_READER'
    | 'GMF_ADVISOR'
    | 'CUSTOM_ACCESS_ORG_LEVEL'
    | 'CUSTOM_ACCESS_SYS_LEVEL';
  organization?: HierarchyObjectView;
  fleet?: HierarchyObjectView;
  identityId?: string;
  cdiProfileId?: string;
  legal?: Legal;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
  identityDataUpdateDate?: string;
  lastSignedInDate?: string;
  onBoardingState?: string;
  eligibleAssetTypes?: EligibleAssetType[];
  invite?: Invite;
  userPreferences?: UserPreferences;
  oviPersonId?: string;
  oviAccountId?: string;
  oviFleetId?: string;
  oviChangeSequence?: string;
  viewedAppSpaceCodes?: (
    | 'BUSINESS_PROFILE'
    | 'VEHICLES'
    | 'DRIVERS'
    | 'USERS'
    | 'GEOFENCES'
  )[];
  type?: 'USER' | 'APP';
  appSettings?: AppSettings;
  driverProfile?: DriverProfile;
};
export type GmPageProfile = {
  items: Profile[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageProfile = {
  result?: GmPageProfile;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type SyncOviPersonsResponseEntry = {
  success?: boolean;
  error?: EntryError;
  profileId?: string;
  personId?: string;
  fleetId?: string;
  changeOp?: 'CREATED' | 'UPDATED' | 'RETIRED' | 'NO_CHANGE';
};
export type SyncOviPersonsResponse = {
  persons?: SyncOviPersonsResponseEntry[];
};
export type GmResponseCommonSyncOviPersonsResponse = {
  result?: SyncOviPersonsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DataChangeTracking = {
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
};
export type SyncOviPersonRequestEntry = {
  hvrChangeOp?: number;
  hvrChangeSequence: string;
  hvrChangeTime?: string;
  personId: string;
  fleetId?: string;
  roleCode: 'manager' | 'driver';
  statusCode:
    | 'active'
    | 'inactive'
    | 'invited'
    | 'pending'
    | 'retired'
    | 'verified';
  firstName?: string;
  lastName?: string;
  userLanguage?: string;
  timezone?: string;
  licenseNumber?: string;
  accountPersonDataChangeTracking: DataChangeTracking;
  addresses?: OviAddress[];
  contacts?: OviContact[];
};
export type SyncOviPersonsRequest = {
  oviAccountId: string;
  cspOrganizationId: string;
  persons: SyncOviPersonRequestEntry[];
};
export type DriverProfileResponse = {
  /** Unique identifier of the driver profile */
  id?: string;
  /** Identifier of the fleet */
  fleetId?: string;
  /** Identifier of the organization */
  organizationId?: string;
  /** Driver's first name */
  firstName?: string;
  /** Driver's last name */
  lastName?: string;
  /** Driver's display name */
  displayName?: string;
  /** Driver's address */
  address?: AddressDto;
  /** Driver's email address */
  email?: string;
  /** Driver's phone number */
  phoneNumber?: string;
  /** Name of the fleet */
  fleetName?: string;
  /** Driver's license number */
  licenseNumber?: string;
  /** State of the driver's license */
  licenseState?: string;
  /** Employee ID */
  employeeId?: string;
  /** Employee start date */
  employeeStartDate?: string;
  /** Additional notes */
  notes?: string;
  /** List of vehicles assigned to this driver */
  assignedVehicles?: DriverAssignedVehicle[];
  /** The invitation status of the driver */
  inviteStatus?: 'PENDING' | 'SENT' | 'EXPIRED' | 'CANCELED' | 'ACCEPTED';
};
export type BulkGetDriversResponse = {
  /** Map of driver IDs to their corresponding driver profile responses */
  drivers?: {
    [key: string]: DriverProfileResponse;
  };
};
export type GmResponseCommonBulkGetDriversResponse = {
  result?: BulkGetDriversResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type BulkGetDriversRequest = {
  /** Driver IDs to fetch (max 100) */
  driverIds: string[];
};
export type OrgAppCreateResponse = {
  id?: string;
  displayName?: string;
  role?: string;
  organization?: HierarchyObjectView;
  appSettings?: AppSettingsDto;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
};
export type GmResponseCommonOrgAppCreateResponse = {
  result?: OrgAppCreateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OrgAppCreateRequest = {
  /** Used as a contact email for App identity. */
  contactEmail: string;
  /** Description of the App identity account. */
  description?: string;
  /** Permissions assigned to the App identity. */
  permissions: string[];
  /** Organization ID the App identity belongs to. */
  organizationId: string;
};
export type DriverVehicleAssignmentRequest = {
  /** Vehicle Identification Number (VIN) */
  vin: string;
};
export type DriverVehicleBulkUnassignRequest = {
  /** Driver IDs (max 100) */
  driverIds: string[];
};
export type AppCreateResponse = {
  id?: string;
  displayName?: string;
  role?: string;
  appSettings?: AppSettingsDto;
  creationDate?: string;
  createdBy?: string;
  updateDate?: string;
  updatedBy?: string;
};
export type GmResponseCommonAppCreateResponse = {
  result?: AppCreateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AppCreateRequest = {
  /** The Contact Email for this App identity. */
  contactEmail: string;
  /** Description of the app identity account. */
  description: string;
  /** The Permissions tied to the App identity account. */
  permissions: string[];
};
export type PaginatedDataResponseDriverProfileResponse = {
  items?: DriverProfileResponse[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseDriverProfileResponse = {
  result?: PaginatedDataResponseDriverProfileResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverProfileCreateResponse = {
  /** Unique identifier of the driver profile */
  id?: string;
  /** Identifier of the fleet */
  fleetId?: string;
  /** Identifier of the organization */
  organizationId?: string;
  /** Driver's first name */
  firstName?: string;
  /** Driver's last name */
  lastName?: string;
  /** Driver's display name */
  displayName?: string;
  /** Driver's email address */
  email?: string;
  /** Driver's phone number */
  phoneNumber?: string;
};
export type GmResponseCommonDriverProfileCreateResponse = {
  result?: DriverProfileCreateResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverProfileCreateRequest = {
  /** Driver's first name */
  firstName: string;
  /** Driver's last name */
  lastName: string;
  /** Driver's email address */
  email: string;
  /** Driver's phone number */
  phoneNumber?: string;
  /** Driver's address information */
  address?: Address;
  /** Latitude coordinate of the driver's address location */
  latitudeOfDriverAddress?: number;
  /** Longitude coordinate of the driver's address location */
  longitudeOfDriverAddress?: number;
  /** Whether the driver is eligible for home charge reimbursement */
  homeChargeReimbursementEnabled?: boolean;
};
export type RecordLastSignedInRequest = {
  /** The profile ID to record the last signed in time for. */
  profileId: string;
  /** The last signed in time to record. */
  lastSignedIn: string;
};
export type CreateAdminUserProfileRequest = {
  firstName: string;
  lastName: string;
  email: string;
  role:
    | 'TECHNICAL_MANAGER'
    | 'SYSTEM_MANAGER'
    | 'SYSTEM_READER'
    | 'GMF_ADVISOR';
  phoneNumber?: string;
};
export type CompletedCancelInviteEntry = {
  id?: string;
};
export type FailedCancelInviteEntry = {
  id?: string;
  errors?: EntryError[];
};
export type CancelInvitesResponseDto = {
  completedEntries?: CompletedCancelInviteEntry[];
  failedEntries?: FailedCancelInviteEntry[];
};
export type GmResponseCommonCancelInvitesResponseDto = {
  result?: CancelInvitesResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CancelInviteEntry = {
  /** The ID of the profile to cancel invitation. */
  id: string;
};
export type CancelInvitesRequestDto = {
  /** The list of entries with details about invitation to cancel. */
  entries: CancelInviteEntry[];
};
export type CompletedResendInviteEntry = {
  id?: string;
};
export type FailedResendInviteEntry = {
  id?: string;
  errors?: EntryError[];
};
export type ResendInvitesResponseDto = {
  completedEntries?: CompletedResendInviteEntry[];
  failedEntries?: FailedResendInviteEntry[];
};
export type GmResponseCommonResendInvitesResponseDto = {
  result?: ResendInvitesResponseDto;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type ResendInviteEntry = {
  id: string;
};
export type ResendInvitesRequestDto = {
  entries: ResendInviteEntry[];
};
export type GmResponseCommonProfile = {
  result?: Profile;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type TermsAndConditionsUrls = {
  termsAndConditions: string;
  privacyPolicy: string;
};
export type LegalRequest = {
  urls: TermsAndConditionsUrls;
  accepted?: boolean;
};
export type CompletedInviteEntry = {
  id?: string;
  email?: string;
  role?: string;
  fleetId?: string;
};
export type FailedInviteEntry = {
  email?: string;
  role?: string;
  fleetId?: string;
  errors?: EntryError[];
};
export type InviteUsersResponse = {
  completedEntries?: CompletedInviteEntry[];
  failedEntries?: FailedInviteEntry[];
};
export type GmResponseCommonInviteUsersResponse = {
  result?: InviteUsersResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type InviteUserEntry = {
  email: string;
  /** Role assigned to the invited user. See Profile.Role enumeration. */
  role: string;
  /** First name of the invited user. Only used for creating Driver Profiles. */
  firstName?: string;
  /** Last name of the invited user. Only used for creating Driver Profiles. */
  lastName?: string;
  /** Phone number of the invited user. Only used for creating Driver Profiles. */
  phoneNumber?: string;
  /** Address of the invited user. Only used for creating Driver Profiles. */
  address?: AddressDto;
  /** Fleet ID to which the invited user is assigned. Only used for creating Driver Profiles. */
  fleetId?: string;
  /** Driver profile information for the invited user, if applicable */
  driverProfile?: DriverProfile;
};
export type InviteUsersRequest = {
  entries: InviteUserEntry[];
};
export type TokenEnrichResponse = {
  /** CS profile id to enrich token with. */
  extension_profileId?: string;
  /** Organization id to enrich token with. */
  extension_organizationId?: string;
};
export type TokenEnrichForSsoRequest = {
  /** Email of the user's SSO account. */
  email?: string;
  /** Unique user ID used to identify them in Azure AD. */
  oid?: string;
};
export type TokenEnrichForCdiRequest = {
  /** Email of the user's CDI account. */
  email: string;
  /** Id of the user's CDI account. */
  cdiId: string;
};
export type GmResponseCommonMapStringSecret = {
  result?: {
    [key: string]: Secret;
  };
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type IdentityIdResponse = {
  identityId?: string;
};
export type GmResponseCommonIdentityIdResponse = {
  result?: IdentityIdResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RetrieveIdentityIdRequest = {
  deviceCode: string;
  userCode: string;
};
export type GmResponseCommonLegalResponse = {
  result?: LegalResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type LegalAgreementDocumentRequest = {
  type: 'GMF_DATA_SHARING';
  accepted: boolean;
  termsVersion: string;
  source: string;
};
export type LegalAgreementRequest = {
  documents: LegalAgreementDocumentRequest[];
};
export type GmResponseCommonDriverProfileResponse = {
  result?: DriverProfileResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverProfileUpdateRequest = {
  /** Driver's first name */
  firstName?: string;
  /** Driver's last name */
  lastName?: string;
  /** Driver's email address */
  email?: string;
  /** Driver's phone number */
  phoneNumber?: string;
  /** Driver's license number for identification and verification purposes */
  licenseNumber?: string;
  /** Full state name where the license has been issued */
  licenseState?: string;
  /** ID of the fleet to which the driver will be assigned */
  fleetId?: string;
  /** Unique employee identifier within the organization */
  employeeId?: string;
  /** Date when the driver started employment */
  employeeStartDate?: string;
  /** Additional notes or comments about the driver */
  notes?: string;
  /** Driver's address information */
  address?: Address;
  /** Latitude coordinate of the driver's address location.
    If this is provided, address and longitude of the driver's address location must also be provided.
     */
  latitudeOfDriverAddress?: number;
  /** Longitude coordinate of the driver's address location.
    If this is provided, address and latitude of the driver's address location must also be provided. */
  longitudeOfDriverAddress?: number;
};
export type GmResponseCommonListTrustedDeviceResponse = {
  result?: TrustedDeviceResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CdiHealthResult = {
  status?: 'UP' | 'DOWN' | 'THROTTLED';
  detail?: string;
  down?: boolean;
};
export type GmResponseCommonCdiHealthResult = {
  result?: CdiHealthResult;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type OffboardStatusResponse = {
  status?: 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'FAILED';
  totalUsers?: number;
  processedUsers?: number;
  failedUsers?: number;
};
export type GmResponseCommonOffboardStatusResponse = {
  result?: OffboardStatusResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type RetrieveResourceCountsResponse = {
  /** Resource counts by resource type. A value of zero means the count completed and no resources were
    found. The fleets count is included only for organization-wide ORG_MANAGER requests. The
    accountAdmins count is included only for ORG_MANAGER profiles. Any applicable count may be omitted
    when it cannot be retrieved, including when the caller lacks the source system's permission.
     */
  counts?: {
    [key: string]: number;
  };
};
export type GmResponseCommonRetrieveResourceCountsResponse = {
  result?: RetrieveResourceCountsResponse;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonSetString = {
  result?: string[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type AppIdentity = {
  id?: string;
  email?: string;
  displayName?: string;
  clientId?: string;
  description?: string;
  primarySecret?: Secret;
  secondarySecret?: Secret;
  creationDate?: string;
  updateDate?: string;
};
export type GmPageAppIdentity = {
  items: AppIdentity[];
  total_items?: number;
  continuation_token?: string;
};
export type GmResponseCommonGmPageAppIdentity = {
  result?: GmPageAppIdentity;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type DriverWithAssignedVehicles = {
  /** Driver's profile ID */
  driverProfileId?: string;
  /** Driver's full name */
  name?: string;
  /** Driver's email address */
  email?: string;
  /** List of VINs associated with this driver */
  vins?: string[];
};
export type PaginatedDataResponseDriverWithAssignedVehicles = {
  items?: DriverWithAssignedVehicles[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseDriverWithAssignedVehicles = {
  result?: PaginatedDataResponseDriverWithAssignedVehicles;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type PaginatedDataResponseProfile = {
  items?: Profile[];
  continuation_token?: string;
  total_items?: number;
};
export type GmResponseCommonPaginatedDataResponseProfile = {
  result?: PaginatedDataResponseProfile;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type GmResponseCommonListProfileResponse = {
  result?: ProfileResponse[];
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type CdiUserProfile = {
  email?: string;
  cdiProfileId?: string;
  cspProfileId?: string;
  cspOrgId?: string;
  firstName?: string;
  lastName?: string;
  role?: string;
  status?: string;
};
export type GmResponseCommonCdiUserProfile = {
  result?: CdiUserProfile;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export type LocationInfo = {
  locale?: string;
  timeZone?: string;
};
export type ContactInfo = {
  email?: string;
  phoneNumber?: string;
  locationInfo?: LocationInfo;
  firstName?: string;
  lastName?: string;
  effectivePreferences?: EffectiveUserPreferencesDto;
};
export type GmResponseCommonContactInfo = {
  result?: ContactInfo;
  targetUrl: string;
  __bd: boolean;
  success: boolean;
  unauthorizedRequest: boolean;
  errors: GmResponseError[];
  traceId?: string;
};
export const {
  useRevokeTrustedDeviceMutation,
  useUpdateOrgLevelAppIdentityMutation,
  useUpdateAppIdentityMutation,
  useDeleteAppIdentityMutation,
  useUpdateProfileCustomPermissionsMutation,
  useResetAppSecretMutation,
  useGetProfileByIdQuery,
  useUpdateUserProfileV1Mutation,
  useUpdateMyLegalDocsMutation,
  useUpdateIdentityIdByUserCodeMutation,
  useCheckTenantAssociationMutation,
  useVerifyOtpMutation,
  useSendOtpMutation,
  useVerifyMfaMutation,
  useOffboardOrganizationUsersMutation,
  useShowGettingStartedMutation,
  useDismissGettingStartedMutation,
  useMarkAppSpaceViewedMutation,
  useValidateOviVehicleSchedulesMutation,
  useValidateOviPersonsMutation,
  useActivateOviPersonsMutation,
  useListOviVehicleSchedulesQuery,
  useSyncOviVehicleSchedulesMutation,
  useListOviPersonsQuery,
  useSyncOviPersonsMutation,
  useBulkGetDriversMutation,
  useCreateProfileCustomPermissionsMutation,
  useAssignVehicleMutation,
  useUnassignVehiclesMutation,
  useCreateAppMutation,
  useGetDriverProfilesQuery,
  useCreateDriverProfileMutation,
  useRecordLastSignedInMutation,
  useCreateAdministrativeUserMutation,
  useCancelInvitesMutation,
  useResendInvitesMutation,
  useAcceptInviteMutation,
  useInviteUsersMutation,
  useEnrichTokenMutation,
  useEnrichToken1Mutation,
  useResetAllAppSecretsMutation,
  useGenerateDeviceCodeMutation,
  useGetIdentityIdByDeviceCodeMutation,
  useRecordCurrentUserLegalAgreementsMutation,
  useGetDriverProfileByIdQuery,
  useUpdateDriverProfileMutation,
  useListTrustedDevicesQuery,
  useProbeCdiQuery,
  useGetOffboardStatusQuery,
  useRetrieveResourceCountsQuery,
  useGetCustomPermissionsQuery,
  useGetAppIdentitiesQuery,
  useFindDriversByVinsQuery,
  useSearchUserProfilesQuery,
  useFindProfilesByOrgIdAndEmailQuery,
  useGetCdiUserProfileQuery,
  useFindAllProfilesBetaQuery,
  useFindAllProfilesByQuery,
  useGetContactInfoQuery,
  useGet20211115MeQuery,
  useDeleteAdministrativeUserMutation,
  useDeleteUserProfileMutation,
} = injectedRtkApi;
